import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also stash access token in localStorage as Bearer fallback
const t = typeof window !== "undefined" ? localStorage.getItem("tb_access_token") : null;
if (t) api.defaults.headers.common["Authorization"] = `Bearer ${t}`;

export function setAccessToken(token) {
  if (token) {
    localStorage.setItem("tb_access_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("tb_access_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
